:host {
  --aha-uploader--background-color: var(--theme-button-ghost-active);
  --aha-uploader--border-color: var(--theme-blue-border);
  --aha-uploader--text-color: var(--theme-primary-text);
  --aha-uploader--link-color: var(--theme-link-text);

  flex: 1 1;
}

#dropzone {
  width: 100%;
  background-color: var(--theme-container-light-background);
  min-height: 110px;
  border: 2px dashed var(--theme-primary-border);
  border-radius: 0.5em;
  gap: 0.5em;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--spacer-4);
  box-sizing: border-box;
}

#dropzone.drag-over {
  background-color: var(--aha-uploader--background-color);
  border-color: var(--aha-uploader--border-color);
}
#dropzone.drag-over-error {
  opacity: 0.5;
}

#dropzone-content {
  text-align: center;
  font-size: var(--font-size-200);
  line-height: var(--line-height-t-200);
  color: var(--aha-uploader--text-color);
  flex-wrap: wrap;
}
#dropzone-content .fa-upload {
  padding-right: var(--spacer-1);
}

#file-list {
  display: flex;
  flex-direction: column;
  gap: 0.5em;
}

.aha-uploader--in-menu {
  padding: var(--aha-menu-item--padding);
  display: flex;
  flex: 1 1;
}

.aha-uploader--in-menu button {
  flex: 1 1;
  text-align: left;
}

:host button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  font-size: var(--default-font-size);
  line-height: var(--default-line-height);
  font-family: var(--default-font-family);
}

#dropzone-button {
  color: var(--aha-uploader--link-color);
  font-size: var(--font-size-200);
  line-height: var(--line-height-t-200);
}

#dropzone-button:hover {
  text-decoration: underline;
}

.upload-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.upload-container.full-modal-width {
  margin-right: calc(-100px + var(--spacer-8));
}

.file-item {
  display: flex;
  align-items: center;
  padding: 8px 16px;
  gap: 12px;
  background: var(--theme-container-light-background);
  border-radius: 8px;
}

.file-item-content {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
}

.file-item-actions {
  display: flex;
  align-items: center;
  gap: 4px;
}

.file-item-actions button {
  padding: 4px;
}

.file-item img,
.file-item video {
  width: 24px;
  height: 24px;
  object-fit: cover;
}

.file-name {
  color: var(--theme-secondary-text);
}
.remove-file {
  color: var(--theme-button-danger);
}
.hidden {
  display: none !important;
}
